module.exports = __webpack_public_path__ + "img/blouse.988497e5.png";